// Added by Sejune Oh on 2019-03-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Component, RefObject, CSSProperties } from 'react'
import { observer } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Intl
import Intl from '@/helper/Intl'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Components
import Dialog, { DialogBaseFCProps } from './Dialog'
import Logger from '@/helper/Logger'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DialogCProps {
  ref?: RefObject<any>
  onConfirm?: () => Promise<{}>
  onCancel?: () => Promise<{}>
  dialogPaperStyle?: CSSProperties
}

export interface DialogContentProps extends DialogBaseFCProps {
  title?: string
  description?: string
  confirmBtn?: string
  cancelBtn?: string
  hideCancelBtn?: boolean
  disableBackdropClick?: boolean
  customBtns?: JSX.Element[]
  hasFileDrop?: boolean
  isRemove?: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
@observer
class DialogContainer extends Component<DialogCProps> {
  shouldOpenOnConfirm?: boolean = false
  isOpen: boolean = false
  dialogInfo: DialogContentProps = {}
  hideCancelBtn: boolean = false
  confirmDisabled: boolean = false
  constructor(props: DialogCProps) {
    super(props)
    makeObservable(this, {
      isOpen: observable,
      dialogInfo: observable,
      hideCancelBtn: observable,
      confirmDisabled: observable,
      handleOpen: action,
      handleClose: action,
      setShouldOpenOnConfirm: action,
      handleConfirm: action,
      setDialogInfo: action,
      setConfirmBtnDisabled: action,
    })
  }
  render() {
    if (!this.isOpen) return <></>
    return (
      <Dialog
        dialogPaperStyle={this.props.dialogPaperStyle}
        isOpen={this.isOpen}
        onClose={this.handleClose}
        onConfirmBtnClick={this.handleConfirm}
        onCancelBtnClick={this.handleClose}
        dialogInfo={this.dialogInfo}
        children={this.props.children}
        confirmDisabled={this.confirmDisabled}
      />
    )
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  handleOpen = () => {
    this.isOpen = true
  }

  handleClose = async () => {
    if (this.props.onCancel) {
      await this.props.onCancel()
    }

    this.isOpen = false
  }

  setShouldOpenOnConfirm = (value: boolean) => {
    this.shouldOpenOnConfirm = value
    return this
  }

  handleConfirm = async () => {
    try {
      if (this.props.onConfirm) await this.props.onConfirm()
      if (this.shouldOpenOnConfirm) {
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    } catch (err) {
      Logger.errLog('Dialog confirm failed !')
      console.log(err.message || err)
      Logger.errLog('=======================')
    }
  }

  setDialogInfo = ({
    title,
    description,
    confirmBtn = Intl.getIntlText({ id: 'htmljs_react.component.dialogcontainer.btn_okay' }),
    cancelBtn = Intl.getIntlText({ id: 'htmljs_react.component.dialogcontainer.btn_cancel' }),
    hideCancelBtn = false,
    disableBackdropClick = false,
    isRemove = false,
    customBtns,
    onFileDrop,
    buttonType,
  }: DialogContentProps) => {
    this.dialogInfo = {
      title,
      confirmBtn,
      cancelBtn,
      description,
      hideCancelBtn,
      disableBackdropClick,
      isRemove,
      customBtns,
      onFileDrop,
      buttonType,
    }

    return this
  }

  setConfirmBtnDisabled = (flag: boolean) => {
    this.confirmDisabled = flag
  }
}

export default DialogContainer
